import type { MoedaBaseComercial, SituacaoBaseComercial } from '../api';

/**
 * Formata valor decimal (string do Postgres numeric) na moeda da Base.
 *
 * Diferente do helper de Oportunidades, que assume BRL: a Base Comercial
 * é parametrizável por moeda (RN-COM-011), então o formato acompanha o
 * campo `moeda` do registro.
 */
export function formatCurrency(
  value: string | null | undefined,
  moeda: MoedaBaseComercial = 'BRL',
): string {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  const locale = moeda === 'BRL' ? 'pt-BR' : moeda === 'USD' ? 'en-US' : 'de-DE';
  return n.toLocaleString(locale, { style: 'currency', currency: moeda });
}

export function formatDateBR(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('pt-BR');
}

export function formatPercent(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return `${n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`;
}

/** Rótulos em pt-BR das 10 situações (Seção 7 da spec). */
export const SITUACAO_LABEL: Record<SituacaoBaseComercial, string> = {
  em_elaboracao: 'Em Elaboração',
  em_revisao: 'Em Revisão',
  em_aprovacao: 'Em Aprovação',
  aprovada: 'Aprovada',
  publicada: 'Publicada',
  vigente: 'Vigente',
  suspensa: 'Suspensa',
  expirada: 'Expirada',
  cancelada: 'Cancelada',
  substituida: 'Substituída',
};

/**
 * Vigência formatada. Data Final nula = vigência indeterminada
 * (RN-COM-003) — não é ausência de dado, é uma escolha do usuário.
 */
export function formatVigencia(
  dataInicio: string | null | undefined,
  dataFim: string | null | undefined,
): string {
  if (!dataInicio) return '—';
  if (!dataFim) return `${formatDateBR(dataInicio)} — indeterminada`;
  return `${formatDateBR(dataInicio)} — ${formatDateBR(dataFim)}`;
}

/** Código exibido com a versão, como aparece nas telas: `BC-2026-000145 v3`. */
export function formatCodigoVersao(codigo: string, versao: number): string {
  return `${codigo} v${versao}`;
}
